import React from 'react'
import { NavLink } from 'react-router-dom';

const Footer = () => {
    return (
    <div className="impressum">
        <ul>
            <NavLink to="/impressum" target="_blank">impressum</NavLink>
            <NavLink to="">&copy;2021</NavLink>
        </ul>
    </div>
    )
}

export default Footer;